import React, { Component } from 'react';
import _ from 'lodash';
import { createArticleSubmission, fetchArticleSubmissionStatus, resetArticleSubmission } from '../../../../actions';
import { connect } from 'react-redux';
import styles from './style.module.scss';
import Modal from '../../../modal';
import ArticleCourseForm from '../../../etc/article-course-form';
import { openModal } from '../../../../actions';
import { MODAL_LOGIN, MODAL_ADD_ARTICLE_TO_COURSE, EXP_CLASSROOM } from '../../../../constants';
import { Spinner } from '../../../etc/spinner';
import { withRouter, Redirect } from 'react-router';
import { NOTIFICATION_TYPE_ERROR, createNotification } from 'react-redux-notify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class ArticleURLForm extends Component
{
    onSubmit = (e) => {
        e.preventDefault();    
        let article_url = e.target.article_url.value;
        this.props.createArticleSubmission(article_url);
    }

    checkStatus = () => {
        const {id} = this.props.submission;
        const {status} = this.props.status;
        if(id && !this.props.loading.FETCH_ARTICLE_SUBMISSION_STATUS) {
            switch (status) {
                case "PROCESSING_COMPLETE":
                case "ARTICLE_MATCHED_QUERYLESS":
                    this.props.openModal(MODAL_ADD_ARTICLE_TO_COURSE);
                    return true;
                case "PROCESSING_ERROR":
                    this.props.createNotification({
                        message: this.props.status.message,
                        type: NOTIFICATION_TYPE_ERROR,
                        duration: 4000,
                        canDismiss: true,
                        icon: <FontAwesomeIcon icon='exclamation-circle' />
                    })
                    this.props.resetArticleSubmission();
                    return false;
                default:
                    this.props.fetchArticleSubmissionStatus(id);
                    return false;
            }
        }
        return false;
    }

    isLoading = () => {
        const {submission} = this.props;
        return submission.id || this.props.loading.CREATE_ARTICLE_SUBMISSION || this.props.loading.FETCH_ARTICLE_SUBMISSION_STATUS;
    }

    renderAddArticleToCourseModal = () => {
      if (this.props.app.APP_EXPERIENCE !== EXP_CLASSROOM || this.props.user.is_instructor !== 1) return;
      const is_loading = this.props.loading.CREATE_ARTICLE_COURSES || this.props.loading.DELETE_ARTICLE_COURSES;

      return (
        <Modal id={MODAL_ADD_ARTICLE_TO_COURSE} title="Edit Article's Courses" loading={is_loading} submit={(() => true)} cancel={null} submitButtonText={'Done'}>
          <ArticleCourseForm />
        </Modal>
      )
    }

    renderForm() {
        return this.props.isLoggedIn ? (
          <form onSubmit={this.onSubmit}>
              <input className={styles.ArticleURLFormInput} type="url" placeholder={this.props.focused ? '' : 'Paste article link here'} name="article_url" autoComplete="off" />
              <button type="submit" className={styles.ArticleURLFormSubmit}>Enter</button>
          </form>
      ) : (
        <React.Fragment>
          <button
            className='button is-primary'
            onClick={e => this.props.openModal(MODAL_LOGIN)}
          >
            Sign In
          </button>
          <input
            placeholder='... to add an article'
            id={styles.ArticleURLFormInputId}
            className={styles.ArticleURLFormInput}
            onClick={e => this.props.openModal(MODAL_LOGIN)} />
        </React.Fragment>
      );
    }

    render() {
        const loading = this.isLoading();
        const { message } = this.props.status;

        if (this.checkStatus() && this.props.status.article_id) {
            const url = '/article/'+this.props.status.article_id+'/discuss';
            this.props.resetArticleSubmission();
            return <Redirect to={url}/>
        }

        return (
            <div className={styles.ArticleURLForm}>
                {
                  loading ?
                  <Spinner loading={loading}>{message}</Spinner> :
                  this.renderForm()
                }
                {this.renderAddArticleToCourseModal()}
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const {app, user, loading, home, auth} = state;
    const submission = home.articleSubmission;
    const status = home.articleSubmissionStatus;
    const isLoggedIn = auth.access_token ? true : false;
    return {
        app,
        user,
        loading,
        submission,
        status,
        auth,
        isLoggedIn
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        createArticleSubmission: (url) => dispatch(createArticleSubmission(url)),
        fetchArticleSubmissionStatus: (id) => dispatch(fetchArticleSubmissionStatus(id)),
        resetArticleSubmission: () => dispatch(resetArticleSubmission()),
        createNotification: (obj) => dispatch(createNotification(obj)),
        openModal: (id) => dispatch(openModal(id))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ArticleURLForm));